/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useLayoutEffect } from "react";
import { useQuery } from "react-query";
import { useFoxTopUpStore } from "../store";
import { BindActivityInfo } from "@/components/top-up/types";
import { ActivityTypeCode } from "project-config/constants";
import request from "project-config/services/request/request";

export function useFetchActivityInfoList() {
  const { setter: setFoxTopUpStore } = useFoxTopUpStore();
  const luckDrawGiftActivityInfo = useFoxTopUpStore(
    (state) => state.luckDrawGiftActivityInfo
  );
  const { data, refetch } = useQuery<BindActivityInfo[]>(
    "/api/rendering/user/activity/template/getSupportActivity",
    { refetchOnWindowFocus: true }
  );

  useLayoutEffect(() => {
    if (!data) {
      setFoxTopUpStore((state) => {
        state.activityInfoList = [];
      });
      return;
    }
    setFoxTopUpStore((state) => {
      state.activityInfoList = data.filter(
        (item) => item.activityType !== ActivityTypeCode.LuckyDrawGift
      );
      state.luckDrawGiftActivityInfo =
        data.find(
          (item) => item.activityType === ActivityTypeCode.LuckyDrawGift
        ) || null;
    });
  }, [data]);

  useEffect(() => {
    const getLotteryPrize = async (id?: number) => {
      const { data } = await request.post(
        "/api/rendering/user/activity/template/getUserPrizeCode",
        { activityId: id }
      );
      setFoxTopUpStore((state) => {
        state.lotteryActivityInfoList = data;
      });
    };
    if (luckDrawGiftActivityInfo) {
      getLotteryPrize(luckDrawGiftActivityInfo.id);
    }
  }, [luckDrawGiftActivityInfo]);

  return {
    activityInfoListRefetch: refetch,
  };
}
